import Plugin from "@ckeditor/ckeditor5-core/src/plugin";

import { CkeditorConstants } from "../../src/utils/ckeditorconstants";
import UnwrapLinkCommand from "./unwraplinkcommand";

const {
  command: { UNWRAP_LINK } } = CkeditorConstants;

export default class UnwrapLinkEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add(
      UNWRAP_LINK,
      new UnwrapLinkCommand(editor)
    );
  }
}
